import React from 'react';
import { ORG_PATHS } from '../constants';
import { injectParams } from '../utils/pathHelpers';
import { AccountLink } from './SideNavOrg';

const OrderHistoryDropdown = ({ billingAccount, pathname, organizationId, setActiveBillingAccount }) => {

  if(!billingAccount) {
    return null
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', paddingLeft: '12px' }}>
      <AccountLink
        key={billingAccount.id}
        to={injectParams(ORG_PATHS.ORDER_HISTORY, {
          organizationId,
          billingAccountId: billingAccount.id
        })}
        style={{
          fontSize: '14px',  
          color: pathname.includes(billingAccount.id) ? '#414042' : '#476692',
          fontWeight: pathname.includes(billingAccount.id) ? 'bold' : 'normal'
        }}
        data-qa-hook={`orderHistory.link.${billingAccount.id}`}
        onClick={() => setActiveBillingAccount(billingAccount.id)}
        activeLink={pathname.includes(billingAccount.id)}
      >
        Acct {billingAccount.accountNumber}
      </AccountLink>
    </div>
  )
};

export default OrderHistoryDropdown;